import ZoomLevels from '../constants/zoom-level-constants';
import {
    getDimensionsConstrainedToContainerWidth,
    getDimensionsConstrainedToContainer,
} from '@99designs/utils/dom';

export function getDimensionsForZoomLevel(zoomLevel, designDimensions, containerDimensions) {
    switch (zoomLevel) {
        case ZoomLevels.FLUID:
            return null;
            break;
        case ZoomLevels.FIT_TO_WIDTH:
            return getDimensionsConstrainedToContainerWidth(designDimensions, containerDimensions);
            break;
        case ZoomLevels.FIT_TO_CONTAINER:
            return getDimensionsConstrainedToContainer(designDimensions, containerDimensions);
            break;
        case ZoomLevels.FIT_TO_NATIVE:
            return designDimensions;
            break;
        default:
            return null;
    }
}

export function getAvailableZoomLevels(designDimensions, containerDimensions) {
    const zoomLevels = [];

    if (!designDimensions || !containerDimensions) {
        return zoomLevels;
    }

    if (canFitToContainer(designDimensions, containerDimensions)) {
        zoomLevels.push(ZoomLevels.FIT_TO_CONTAINER);
    }

    if (canFitToWidth(designDimensions, containerDimensions)) {
        if (
            !isEqualDimensions(
                getDimensionsConstrainedToContainerWidth(designDimensions, containerDimensions),
                getDimensionsConstrainedToContainer(designDimensions, containerDimensions)
            )
        ) {
            zoomLevels.push(ZoomLevels.FIT_TO_WIDTH);
        }
    }

    zoomLevels.push(ZoomLevels.FIT_TO_NATIVE);
    return zoomLevels;
}

export function canFitToContainer(designDimensions, containerDimensions) {
    return !(
        designDimensions.width < containerDimensions.width &&
        designDimensions.height < containerDimensions.height
    );
}

export function canFitToWidth(designDimensions, containerDimensions) {
    return (
        designDimensions.width > containerDimensions.width &&
        designDimensions.height > containerDimensions.height
    );
}

export function isEqualDimensions(a, b) {
    return a.width === b.width && a.height === b.height;
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/lib/zoom.js